import { Component, EventEmitter, Input, Output } from "@angular/core";
import { User, userToString } from "src/services/user/user.interface";

@Component({
  selector: "rc-user-search-result",
  templateUrl: "./user-search-result.component.html",
  styleUrls: ["./user-search-result.component.scss"],
  standalone: false,
})
export class UserSearchResultComponent {
  @Input() public user: User;
  @Output() onClick = new EventEmitter<User>();

  constructor() {}

  public readonly userToString = userToString;
}
